<template>
  <v-card>
    <v-card-text class="pt-4">
      <template v-if="zipsLoading || branchOfficesLoading">
        <div class="text-center" >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
      </template>
      <Mapbox
        v-else
        v-model="zips"
        :branch-offices="branchOffices"
        read-only
        full-screen-map
        hide-link-to-company
        :zoom="6"/>
    </v-card-text>
  </v-card>
</template>

<script>
import CompaniesAPI from '@/api/companies'
import BranchOfficesAPI from '@/api/branchOffices'
import Mapbox from '../../components/Mapbox.vue'

export default {
  data() {
    return {
      zipsLoading: false,
      branchOfficesLoading: false,
      zips: '',
      branchOffices: [],
    }
  },
  created() {
    this.loadZips()
    this.loadBranchOffices()
  },
  methods: {
    loadZips() {
      this.zipsLoading = true
      CompaniesAPI.getAllSuppliableZips().then((response) => {
        this.zips = response.zips.join(',')
        this.zipsLoading = false
      })
    },
    loadBranchOffices() {
      this.branchOfficesLoading = true
      BranchOfficesAPI.getAllBranchOffices().then((response) => {
        this.branchOffices = response
        this.branchOfficesLoading = false
      })
    },
  },
  components: {
    Mapbox,
  },
}
</script>
